import { useState, useEffect } from 'react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Default about data as fallback
const DEFAULT_ABOUT_DATA = {
  title: "Über Nessenius Garten & Landschaftsbau",
  text: `Mit Leidenschaft und Fachkenntnis kümmern wir uns seit Jahren um Gärten in Nörten-Hardenberg und Umgebung. 

Als inhabergeführtes Unternehmen legen wir großen Wert auf persönlichen Service, Zuverlässigkeit und handwerkliche Qualität. Ob regelmäßige Gartenpflege, anspruchsvolle Baumarbeiten oder komplexe Erdarbeiten – wir packen jede Aufgabe mit dem gleichen Engagement an.

Unser Ziel ist es, dass Sie sich in Ihrem Garten wohlfühlen und die Natur genießen können, während wir uns um die Arbeit kümmern.`,
  values: [
    {
      title: "Zuverlässig",
      description: "Pünktlich, verbindlich und auf Ihre Zufriedenheit fokussiert"
    },
    {
      title: "Kompetent",
      description: "Fachgerechte Ausführung mit langjähriger Erfahrung"
    },
    {
      title: "Fair",
      description: "Transparente Preise und ehrliche Beratung"
    }
  ]
};

export const useAboutData = () => {
  const [aboutData, setAboutData] = useState(DEFAULT_ABOUT_DATA);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAboutData = async () => {
      try {
        const response = await fetch(`${BACKEND_URL}/api/site-content/about`);
        if (response.ok) {
          const data = await response.json();
          if (data && data.content) {
            const c = data.content;
            setAboutData({
              title: c.title || DEFAULT_ABOUT_DATA.title,
              text: c.text || DEFAULT_ABOUT_DATA.text,
              values: c.values || DEFAULT_ABOUT_DATA.values
            });
          }
        }
      } catch (error) {
        console.error('Error fetching about data:', error);
        // Keep default on error
      } finally {
        setLoading(false);
      }
    };

    fetchAboutData();
  }, []);

  return { aboutData, loading };
};

export default useAboutData;
